// extracted by mini-css-extract-plugin
export default {"user-search-selector__userdisabled":"UserSearchSelector_user-search-selector__userdisabled__+uM2d"};